import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import cn from 'classnames'
import Grid from '@material-ui/core/Grid'
import { Icon, IconButton, Button, Collapse } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { PROJECTED_SITES_MANAGER_FRESHWATER_FILTERS } from 'constants/projectedSitesManager'
import { PROJECTED_SITES_MANAGER } from 'constants/exportTypes'
import {
  fetchProjectedSitesManagerClients,
  fetchProjectedSitesManagerList,
  setPsfs,
  clearPsfs,
} from 'reducers/projectedSitesManager/reducer'
import Psfs from 'lib/psfs/Psfs'
import ExportButton from 'components/common/ExportButton'
import Pagination from 'lib/psfs/Pagination'
import { FilterComponent } from 'routes/App/Apps/MonitorsAndAlerts/SiteFilters/FilterComponent'
import { ReactComponent as IconFilter } from 'assets/img/open-filters.svg'
import messages from '../translate'
import { FILTER_TO_ID_FRESHWATER } from '../constants'

class FreshwaterFilterBar extends Component {
  state = {
    setInitialData: false,
    isOpenFilters: false,
    showBadge: false,
    showDisabledRows: true,
    filtersArr: PROJECTED_SITES_MANAGER_FRESHWATER_FILTERS,
    initialData: PROJECTED_SITES_MANAGER_FRESHWATER_FILTERS,
  }

  componentDidMount() {
    const {
      setPsfs,
      location: { pathname },
      fetchProjectedSitesManagerClients,
      siteType,
    } = this.props
    const psfs = new Psfs(pathname)

    setPsfs(psfs)
    fetchProjectedSitesManagerClients(siteType)
  }

  componentWillUnmount() {
    const { clearPsfs } = this.props

    clearPsfs()
  }

  componentDidUpdate(prevProps) {
    const {
      fetchProjectedSitesManagerList,
      storePsfs: newStorePsfs,
      freshwaterFilters,
      siteType: newSiteType,
      selectedSnapshot: newSelectedSnapshot,
    } = this.props
    const {
      freshwaterFilters: prevFilters,
      storePsfs: prevStorePsfs,
    } = prevProps
    const { filtersArr } = this.state

    if (!isEqual(freshwaterFilters, prevFilters)) {
      const newFilters = filtersArr.map(filter => {
        const newFilter = { ...filter }
        const { filterType } = filter
        const filterTypes = freshwaterFilters.get(filterType)
        const data = filterTypes && filterTypes.map(this.updateListData)
        newFilter.data = data
        newFilter.value = []

        return newFilter
      })

      const {
        storePsfs: { path },
      } = this.props
      const psfs = new Psfs(path)
      const filters = psfs.filtersObj.getFilters()

      const filtersWithSavedValues = newFilters.map(filter => {
        const filterId = FILTER_TO_ID_FRESHWATER[filter.storeName]
        if (Object.keys(filters).includes(filterId)) {
          const savedFilter = filters[filterId]

          return {
            ...filter,
            value: savedFilter.values.map(item =>
              filter.data.find(el => el[filterId] === +item),
            ),
          }
        }

        return filter
      })

      this.setState(
        {
          initialData: newFilters,
          filtersArr: filtersWithSavedValues,
          isOpenFilters: !!Object.keys(filters).length,
        },
        () => {
          const data = this.getFiltersData()

          this.fetchDataByFilter(data, 'client', false)
        },
      )
    }

    if (!isEqual(prevStorePsfs, newStorePsfs)) {
      fetchProjectedSitesManagerList({
        psfs: newStorePsfs,
        siteType: newSiteType,
        snapshot: newSelectedSnapshot,
      })
    }
  }

  getFiltersData() {
    const { filtersArr } = this.state

    return filtersArr.reduce((acc, { value, storeName: itemStoreName }) => {
      if (value && !!value.length) {
        acc[itemStoreName] = value.map(({ id }) => id)
      }

      return acc
    }, {})
  }

  showBadge = () => {
    const { filtersArr } = this.state
    const showBadge = filtersArr.some(
      ({ value, data }) => value.length !== data.length,
    )

    this.setState({ showBadge })
  }

  resetFilters = event => {
    const {
      setPsfs,
      storePsfs: { path },
      fetchProjectedSitesManagerClients,
      siteType,
    } = this.props

    event.stopPropagation()

    this.setState(
      () => ({
        setInitialData: true,
        showDisabledRows: true,
        showBadge: false,
      }),
      () => {
        const psfs = new Psfs(path)

        psfs.filtersObj.clearAll()
        psfs.addPagination(1, 100)

        setPsfs(psfs)
        fetchProjectedSitesManagerClients(siteType)
      },
    )
  }

  getUpdatedFilters = updatedData => {
    const { filtersArr, initialData } = this.state
    let updatedArr = [...filtersArr]

    if (!updatedData) {
      return updatedArr
    }

    if (Object.keys(updatedData).length) {
      Object.keys(updatedData).forEach(dataStoreName => {
        updatedArr = updatedArr.map(item => {
          if (item.storeName === dataStoreName) {
            const idNames = {
              site: 'siteId',
              region: 'id',
              client: 'clientId',
            }
            const matchFromInitial = initialData.find(
              ({ storeName }) => storeName === dataStoreName,
            )
            const getUpdatedData = field =>
              !!matchFromInitial &&
              matchFromInitial[field].filter(data =>
                updatedData[dataStoreName].some(
                  id => id === data[idNames[dataStoreName]],
                ),
              )
            const updatedItemData = getUpdatedData('data')
            const updatedItemValue = getUpdatedData('value')

            return {
              ...item,
              data: updatedItemData,
              value: updatedItemValue,
            }
          }

          return item
        })
      })
    }

    return updatedArr
  }

  fetchDataByFilter = (data, storeName, isFilterChange = true) => {
    const { showDisabledRows } = this.state
    const {
      storePsfs: { searchObj, path },
      setPsfs,
    } = this.props
    const updatedFiltersArr = this.getUpdatedFilters(data[storeName])
    const psfs = new Psfs(path)
    psfs.filtersObj.clearAll()

    if (data[storeName]) {
      psfs.addFilter('clientId', data.clientName, 'in')
    }

    if (!showDisabledRows) {
      psfs.addFilter('enabled', !showDisabledRows)
    }

    psfs._search = searchObj
    psfs._pagination = new Pagination()
    psfs.addPagination(1, 100)

    this.setState({ filtersArr: updatedFiltersArr })

    if (isFilterChange) {
      setPsfs(psfs)
    }
  }

  handleDeactivateRows = () => {
    const { showDisabledRows, filtersArr, initialData } = this.state
    const {
      storePsfs: { path },
      setPsfs,
    } = this.props
    const psfs = new Psfs(path)
    const showBadge = filtersArr !== initialData || showDisabledRows

    if (showDisabledRows) {
      psfs.addFilter('enabled', showDisabledRows)
    } else {
      psfs.clearFilter('enabled')
    }

    this.setState(
      {
        showDisabledRows: !showDisabledRows,
        showBadge,
      },
      () => {
        setPsfs(psfs)
      },
    )
  }

  handleSetInitialData = flag => {
    this.setState({ setInitialData: flag })
  }

  handleFilterChange = (value, storeName) => {
    const { filtersArr } = this.state
    const newArr = filtersArr.map(item => {
      if (item.storeName === storeName) {
        return {
          ...item,
          value,
        }
      }

      return item
    })

    if (!isEqual(filtersArr, newArr)) {
      this.setState(
        {
          filtersArr: newArr,
        },
        () => {
          const data = this.getFiltersData()

          this.fetchDataByFilter(data, storeName)
          this.showBadge()
        },
      )
    }
  }

  updateData = (data, field, id) => ({
    id: data[id],
    name: data[field],
    storeName: data[field],
    translateName: data[field],
  })

  updateListData = data => ({
    ...data,
    ...this.updateData(data, 'clientName', 'clientId'),
  })

  toggleFilterBar = () => {
    this.setState(prevState => ({
      isOpenFilters: !prevState.isOpenFilters,
    }))
  }

  renderControls = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const { showBadge, showDisabledRows, isOpenFilters } = this.state

    return (
      <>
        <div className="button" onClick={this.handleDeactivateRows}>
          <Icon>{showDisabledRows ? 'visibility' : 'visibility_off'}</Icon>
          <div className="text">{formatMessage(messages.deactivatedRows)}</div>
        </div>
        <div
          className={cn('button', {
            active: isOpenFilters,
            'has-reset': showBadge,
          })}
          onClick={this.toggleFilterBar}>
          <IconButton className="icon-btn">
            <IconFilter />
          </IconButton>
          <div className="text">{formatMessage(messages.showFilters)}</div>
          {showBadge && (
            <div className="reset-filters" onClick={this.resetFilters} />
          )}
        </div>
      </>
    )
  }

  renderFilters = () => {
    const { setInitialData, filtersArr } = this.state
    const {
      intl: { formatMessage },
    } = this.props

    return filtersArr.map(
      filter =>
        Array.isArray(filter.value) && (
          <Grid item key={filter.id}>
            <FilterComponent
              {...filter}
              allSelectedExistInList
              handleFilterChange={this.handleFilterChange}
              formatMessage={formatMessage}
              disableUnderline={false}
              setInitialData={setInitialData}
              handleSetInitialData={this.handleSetInitialData}
            />
          </Grid>
        ),
    )
  }

  render() {
    const {
      intl: { formatMessage },
      storePsfs,
      onOpenForm,
      siteType,
      selectedSnapshot: snapshot,
    } = this.props
    const { isOpenFilters } = this.state

    const exportButtonParams = {
      psfs: storePsfs,
      type: PROJECTED_SITES_MANAGER,
      siteType,
      snapshot,
    }

    return (
      <>
        <Grid item>
          <Grid container justify="flex-end">
            <Grid item className="controls">
              {this.renderControls()}
            </Grid>
          </Grid>
          <Grid item className="collapsed-filter">
            <Collapse in={isOpenFilters}>{this.renderFilters()}</Collapse>
          </Grid>
        </Grid>
        {snapshot === 'main-table' && (
          <Button
            className="add-row-btn"
            variant="contained"
            color="primary"
            type="button"
            size="medium"
            onClick={() => onOpenForm(null)}>
            {formatMessage(messages.newRow)}
          </Button>
        )}
        <ExportButton params={exportButtonParams} />
      </>
    )
  }
}

export default connect(
  state => ({
    storePsfs: state.getIn(['projectedSitesManager', 'storePsfs']),
    freshwaterFilters: state.getIn([
      'projectedSitesManager',
      'freshwaterFilters',
    ]),
  }),
  {
    setPsfs,
    fetchProjectedSitesManagerList,
    fetchProjectedSitesManagerClients,
    clearPsfs,
  },
)(injectIntl(FreshwaterFilterBar))
